import { createContext, useContext, useEffect, useState } from "react";
import API, { apiErrorMessage } from "../lib/api";

const OwnerCtx = createContext(null);
export const useOwner = () => useContext(OwnerCtx);

export function OwnerProvider({ children }) {
  const [phase, setPhase] = useState("checking"); // checking | setup | login | authed

  useEffect(() => {
    (async () => {
      try {
        const { data } = await API.get("/owner/auth/status");
        if (!data.configured) {
          setPhase("setup");
          return;
        }
        await API.get("/owner/auth/me");
        setPhase("authed");
      } catch {
        setPhase("login");
      }
    })();
  }, []);

  const setup = async (password, setError, setLoading) => {
    try {
      setLoading(true);
      await API.post("/owner/auth/setup", { password });
      setPhase("authed");
    } catch (e) {
      setError(apiErrorMessage(e, "Setup failed. Please try again."));
    } finally {
      setLoading(false);
    }
  };

  const login = async (password, setError, setLoading) => {
    try {
      setLoading(true);
      await API.post("/owner/auth/login", { password });
      setPhase("authed");
    } catch (e) {
      setError(apiErrorMessage(e, "Sign in failed. Please try again."));
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await API.post("/owner/auth/logout");
    } finally {
      setPhase("login");
    }
  };

  return (
    <OwnerCtx.Provider value={{ phase, setup, login, logout }}>{children}</OwnerCtx.Provider>
  );
}
